import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";

import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { CopyTextDirective } from "./directives/copy-text.directive";
import { TagInputComponent } from "./tag-input/tag-input.component";
import { UIModule } from "./ui/ui.module";
import { SafePipe } from "./pipes/sanitizer-pipe";
import { FormatCnpjPipe } from "./pipes/format-cnpj.pipe";
import { ConflictResolutionModalComponent } from "../pages/timesheet-management/register/components/conflict-resolution-modal/conflict-resolution-modal.component";

@NgModule({
  declarations: [TagInputComponent, CopyTextDirective, SafePipe, FormatCnpjPipe, ConflictResolutionModalComponent],
  imports: [CommonModule, UIModule, NgbModule, FormsModule],
  exports: [TagInputComponent, CopyTextDirective, SafePipe, FormatCnpjPipe, ConflictResolutionModalComponent],
})
export class SharedModule { }
